






















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';

import Customer, { customerInitValue } from '@/types/customer/Customer';
import UserInterface from '@/types/app/IUser';
import CustomerService from '@/services/customerService';
import { getFileNameFromLink } from '@/utils/fileName';
import {
  ImportAccountHeader,
  ImportInterestHeader,
} from '@/components/headers/header-import';
import Header from '@/types/app/header';
import formatDate from '@/utils/formatDate';
import Endpoint from '@/utils/endpoint';
import * as XLSX from 'xlsx';
import ModalSuccess from '@/components/common/ModalSuccess.vue';
import { CustomerSelectValue } from '@/utils/getCustomers';
import AccountService from '@/services/accountService';
import AccountInterface, { accountInitialValue } from '@/types/app/accounts';
import Interest from '@/types/app/excelData';
import ErrorService from '@/services/erroService';
import { ImportFormFieldtHeader, ImportUsertHeader } from '@/components/headers/header-import-cip';
import BaseComponent from '@/utils/baseComponent';

interface ProductFund {
  fundName: string;
  fundSiteName: string;
  fundId: string;
}

interface FormField {
  value: string;
  key: string;

}

interface UserCipImport {
  userId: string;
  email: string;
  perfilName: string;
  perfilType: string;
  fields: any;
  nonUs: boolean;
}

@Component({
  components: { ModalSuccess },
  data: () => ({
    isLCM: false,
    endpoint: new Endpoint(),
  }),
})
export default class CIPImport extends BaseComponent {
  @Getter('getModalImportInterestState', { namespace: 'customer' })
  modalImportInterestState!: boolean;
  @Getter('getActiveCustomers', { namespace: 'customer' }) customersActive!: Customer[];
  @Getter('getCustomersAll', { namespace: 'customer' }) customersAll!: Customer[];
  @Action('setModalImportInterestState', { namespace: 'customer' })
  setModalImportInterestState!: any;
  height = '';
  customer: Customer = customerInitValue;
  @Getter('getUser', { namespace: 'auth' }) user!: UserInterface;
  @Action('setCustomers', { namespace: 'customer' }) setCustomers!: any;
  headersUsers: Header[] = ImportUsertHeader.header;
  headersForms: Header[] = ImportFormFieldtHeader.header;
  private accountService = new AccountService(this.$http);
  errorCreate = false;
  openSuccessModal = false;
  openSuccessModalMessage =
    'Imported interested and accounts partially, some lines with error in the downloaded file';
  loading = false;
  getFileNameFromLink = getFileNameFromLink;
  formatDate = formatDate;
  isLCM = false;
  private endpoint = new Endpoint();
  formsField = new Array<UserCipImport>();
  valid = true;
  customerService = new CustomerService(this.$http);
  funds: ProductFund[] = [];
  customers: Customer[] = [];
  errorMessage!: string;

  headerInterest = [
    'Email',
    'FirstName',
    'LastName',
    'Country',
    'Phone',
    'Classification',
    'TypePerson',
  ];
  headerAccount = ['Email', 'AccountNumber', 'FundName'];



  handleFileImport() {
    // Trigger click on the FileInput
    (this.$refs.uploader as HTMLElement).click();
  }


  async mounted() {
    // this.loading = true;
    // const [fundResponse, customerResponse, accountResponse] = await Promise.all(
    //   [
    //     this.getProductFunds(),
    //     this.getCustomers(),
    //     this.accountService.getAccounts(),
    //   ]
    // );
    // this.funds = fundResponse;
    // this.customers = customerResponse;
    // this.accounts = accountResponse;
    // this.loading = false;
  }

  clear() {
    this.formsField = [];
    this.errorMessage = "";
    this.errorCreate = false;
  }

  importData(event: any) {
    const file = event.target.files ? event.target.files[0] : null;
    if (file) {
      this.clear();
      this.loading = true;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        /* Parse data */
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });
        const first_worksheet = wb.Sheets[wb.SheetNames[0]];
        const dataImport = XLSX.utils.sheet_to_json(first_worksheet, { header: 1, blankrows: true, raw: false, defval: '' });

        this.customerService
          .importCip(dataImport)
          .then((resp: any) => {
            if (resp.hasError) {
              this.errorMessage = resp.messageError.join('<br />');
            }
            
            this.formsField = resp.data;
            if (this.formsField?.length > 0) {
              this.formsField.map(f => {
                const keys = Object.keys(f.fields);
                f.fields = keys.map(k => ({ key: k, value: f.fields[k] }));
              });
              this.openSuccessModalMessage = `Imported CIP data for customers into table` + (resp.hasError? `, with some errors:<br /><br />${this.errorMessage}` : '');
              this.openSuccessModal = true;
            }
            else {

              this.showError(this.errorMessage);
            }

            this.loading = false;
          })
          .catch((result: any) => {
            ErrorService.onError(result);
            this.errorMessage = result.messageError.join('<br />');
            this.errorCreate = true;
            this.loading = false;
          });


      };

      reader.readAsBinaryString(file);
    }
  }


  download(interests: any[], accounts: any[]) {
    const nameTemplate = 'template_export_';
    const dataInterestJson = XLSX.utils.json_to_sheet([
      { Key: 'INVESTOR NAME', Values: '' },
      { Key: 'INVESTOR E-MAIL', Values: '' },
      { Key: 'PERFIL TYPE', Values: '' },
      { Key: 'INVESTOR ID PIPEDRIVE', Values: '' },
      { Key: 'NONUS', Values: '' },
    ], {
      header: ['Key', 'Values'],
    });
    const wbInterest = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wbInterest, dataInterestJson, 'BulkUsers');
    XLSX.writeFile(wbInterest, nameTemplate + new Date().getTime() + '.xlsx');
  }
}
